export enum CanvasModelState { NoChanges, New, Changed, Deleted }